import { hasWindow } from './context'

/**
 * Returns the creationId from the url path
 */
export const getCreationId = (): string | null => {
  if (!hasWindow()) return null
  return window.location.pathname.split('/')[1]
}
